import { apiClient } from '@/shared/api/http-client';

import type {
    GetPaymentListOutput,
    PaymentListFilters,
    RecordPaymentOutput,
    RecordPaymentRequest,
    RefundPaymentInput,
    RefundPaymentOutput,
} from '../model/payment.types';

export const paymentApi = {
    record: async (
        request: RecordPaymentRequest,
        signal?: AbortSignal,
    ): Promise<RecordPaymentOutput> => {
        return apiClient.post('/payment/record', request, signal);
    },

    refund: async (
        request: RefundPaymentInput,
        signal?: AbortSignal,
    ): Promise<RefundPaymentOutput> => {
        return apiClient.post('/payment/refund', request, signal);
    },

    getList: async (
        filters: PaymentListFilters,
        signal?: AbortSignal,
    ): Promise<GetPaymentListOutput> => {
        const params = new URLSearchParams({ clientId: filters.clientId });

        if (filters.kind) params.set('kind', filters.kind);
        if (filters.pageSize) params.set('pageSize', filters.pageSize.toString());
        if (filters.cursor) params.set('cursor', filters.cursor);

        return apiClient.get(`/payment/list?${params.toString()}`, signal);
    },
};
